import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import * as LandingStatus from '../../constants/LandingStatus';
import { useLiveFeedContext } from '../../contexts/LiveFeedContext';
import Item from '../Feed/Item';

const FromNotificationItem = ({
  hiddenUserIds,
  onDeleteItem,
  onReportContent,
  onSetHiddenUserIds,
  onTogglePostLike,
  onUpdateItem,
}) => {
  const { config } = useLiveFeedContext();
  const [searchParams] = useSearchParams();
  const { currentUser } = useDefaultAppContexts();

  const [itemFromNotification, setItemFromNotification] = useState(null);

  const fromNotification = searchParams.get('from_notification');
  const fromEmail = searchParams.get('from_email');
  const userPostId = searchParams.get('posts_feed_post_id');
  const tripId = searchParams.get('trip_id');
  const currentId = searchParams.get('current_id');

  const fetchItem = useCallback(() => {
    if (fromNotification || fromEmail) {
      if (userPostId) {
        fetchUserPost();
      }
      if (tripId) {
        fetchTrip();
      }
      if (currentId) {
        fetchCurrent();
      }
    }
  }, [userPostId, tripId, currentId, fromNotification, fromEmail]);
  const fetchUserPost = useCallback(() => {
    axios
      .get(Routes.user_post_path(currentUser.id, userPostId))
      .then(({ data: { feed_post: post } }) => {
        setItemFromNotification(post);
      });
  }, [userPostId]);
  const fetchTrip = useCallback(() => {
    axios
      .get(Routes.user_trip_path(currentUser.id, tripId))
      .then(({ data: { trip } }) => {
        setItemFromNotification(trip);
      });
  }, [tripId]);
  const fetchCurrent = useCallback(() => {
    axios
      .get(Routes.user_location_path(currentUser.id, currentId))
      .then(({ data: { location } }) => {
        setItemFromNotification(location);
      });
  }, [currentId]);

  useEffect(() => {
    fetchItem();
  }, [userPostId, tripId, currentId, fromEmail, fromNotification]);

  if (!itemFromNotification) {
    return null;
  }

  return (
    <Item
      data-testid="notification-landing"
      hiddenUserIds={hiddenUserIds}
      isActive={LandingStatus.FROM_NOTIFICATIONS}
      item={itemFromNotification}
      onDeleteItem={onDeleteItem}
      onReportContent={onReportContent}
      onSetHiddenUserIds={onSetHiddenUserIds}
      onTogglePostLike={onTogglePostLike}
      onUpdateItem={onUpdateItem}
      parentType={config.type}
    />
  );
};

FromNotificationItem.props = {
  hiddenUserIds: PropTypes.array.isRequired,
};

FromNotificationItem.defaultProps = {
  itemMinHeight: 50,
  overscanRowCount: 5,
  threshold: 5,
};

export default FromNotificationItem;
